<template lang="pug">
.container
  Details-Winner(v-if="$root.show_details", root-variable="show_details", :winner-val="getWinnerJson", :concurso-val="getConcursoJson")
  .base-alert(v-if="show_alert")
    .overflow-alert(@click="show_alert = false")
    .alert-content
      .msg ¿Estas seguro de realizar esta acción?
      button.button(@click='confirmOption') SI
      button.button.cancel(@click='show_alert = false') NO
  .square(v-show="!$root.show_details || show_alert")
    .box-win
      .info-text(v-if="first_time") {{ count }}
        span(:class="{ 'active' : loaded_count }") ¡PARTICIPANTES PARA ESTE MES!
      .info-text.no-show(ref="loading")
        .loading-text PREPARANDO MOTORES...
      .roulette(ref="roulette")
        .template(v-for="(participant, index) in dataConcurse", @click="showDetailsWinner(participant.id)", :class="{ 'winner' : participant.id == winner.id }" :id="'participant-id-' + participant.id", :key="index")
          span.matricula {{ participant.matricula }}
          span.name {{ participant.nombre }}
    //.arrow(ref="arrow", :class="{ 'active' : loaded_count &&  !first_time }")
    button.button(@click='start', v-if="loaded_count", :class="{ 'is-loading' : $root.sending }", :disabled="!loaded_count || $root.sending") {{ winnerData || winner.id != null ? 'Seleccionar otro Ganador' : 'Seleccionar Ganador' }}
    .txt(ref="txt")
    button.button(@click='$root.show_details=true', v-if="first_show") Ver Ganador Seleccionado
    .txt(ref="txt_view")
</template>

<script>

import DetailsWinner from './DetailsWinner'

export default {
  props: {
    code: Object,
    dataConcurse: Array,
    winnerData: Object
  },
  data() {
    return {
      offset: 0,
      first_time: true,
      first_show: true,
      count: 0,
      loaded_count: false,
      winner: {
        id:null
      },
      show_alert: false,
      confirm: false
    }
  },
  components: {
    DetailsWinner
  },
  computed: {
    getWinnerJson(){
      return JSON.stringify(this.winner)
    },
    getConcursoJson(){
      return JSON.stringify(this.code)
    }
  },
  methods: {
    confirmOption() {
      let vm = this
      vm.show_alert = false
      vm.confirm = true
      vm.start()
    },
    showDetailsWinner(id) {
      let vm = this
      if (id == vm.winner.id) {
        vm.$root.show_details = true
      }
    },
    countParticipants() {
      let vm = this
      let c = setInterval(function() {
        vm.count += Math.floor(Math.random() * 30) + 10
        if ((vm.count > vm.dataConcurse.length) || (vm.count < 0)) {
          vm.count = vm.dataConcurse.length
          clearInterval(c)
          vm.loaded_count = true
        }
      }, 20)
    },
    start() {
      let vm = this
      if ((!vm.confirm && vm.winnerData != null ) || (!vm.confirm && vm.winner.id != null )) {
        vm.show_alert = true
      } else {
        const { roulette, loading, arrow, txt } = vm.$refs
        vm.$root.sending = !vm.$root.sending
        vm.first_time = false
        vm.first_show = false
        loading.style.opacity = 1
        roulette.style.opacity = 0

        axios.get(`/api/concursos/${vm.code.code}/setRandomWinner`)
        .then(function (response) {
          vm.winner = response.data.data
          vm.confirm = false
          vm.$root.sending = !vm.$root.sending
          loading.style.opacity = 0
          roulette.style.opacity = 1
          document.getElementById('participant-id-' + vm.winner.id).scrollIntoView({block: 'start', behavior: 'smooth'})
          vm.offset = 0
        })
        .catch(function (error) {
          console.log(error)
          vm.$root.sending = !vm.$root.sending
          loading.style.opacity = 0
          roulette.style.opacity = 1
        })
      }
    },
  },
  mounted() {
    this.countParticipants()
    if(this.winnerData != null){
      this.winner = this.winnerData
    }else{
      this.first_show = false
    }
  }
}
</script>

<style lang="sass" scoped>
  .overflow-alert
    position: fixed
    width: 100%
    height: 100%
    top: 0
    left: 0
    background: rgba(0, 0, 0, 0.47)
    z-index: 3
    cursor: pointer
  .alert-content
    position: fixed
    width: 70%
    text-align: center
    background: #FF9800
    top: 50%
    left: 50%
    transform: translate(-50%, -50%) skewY(-5deg)
    z-index: 4
    padding: 50px
    border-radius: 50px
    font-size: 25px
    overflow: hidden
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1), 0 3px 10px rgba(0, 0, 0, 0.07)
    &:after
      content: ''
      position: absolute
      width: 500%
      height: 500%
      background: url(../../../images/lines.svg)
      top: 50%
      left: 50%
      z-index: -1
      background-repeat: no-repeat
      background-position: center
      transform: translate(-50%, -50%)
      animation: 60s moveBgLines ease infinite alternate
  .winner
    background: rgba(255, 235, 59, 1)
    //animation: fade .4s ease infinite alternate
    cursor: pointer
    position: relative
    transition: all .3s ease
    &:hover
      background: #fcbf00
    &:after
      content: ''
      position: absolute
      width: 0
      height: 0
      border-left: 20px solid transparent
      border-right: 20px solid transparent
      border-top: 30px solid #a289cf
      top: 0
  .container
    z-index: 1
  .info-text
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    font-size: 60px
    font-weight: bold
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    transition: all .3s ease
    & .loading-text
      font-size: 17px
      text-align: center
    &.no-show
      opacity: 0
    & span
      font-size: 20px
      text-align: center
      transition: all .3s ease
      height: 0px
      overflow: hidden
      &.active
        height: 90px

  .square
    width: 500px
    margin: 60px auto
    margin-top: 60px
    display: flex
    flex-direction: column
    align-items: center
    transform: skewY(-5deg)
    animation: fade .3s ease

  .box-win
    width: 600px
    height: 200px
    background: #FFF
    overflow: hidden
    border: 8px solid #a289cf
    background: linear-gradient(to bottom, #FFF 50%, #EEE 50%)
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1), 0 3px 10px rgba(0, 0, 0, 0.07)
    position: relative

  .roulette
    width: 400px
    height: 200px
    display: inline-flex
    opacity: 0
    transition: all .3s ease
    & div
      min-width: 200px
      height: 183px
      display: inline-flex
      flex-direction: column
      align-items: center
      justify-content: center
      border-right: 2px solid rgba(162, 137, 207, 0.4)
      padding: 0 10px
      & i
        font-size: 72px
      & span
        font-size: 32px
        text-align: center
        &.name
          font-size: 15px
          display: -webkit-box
          -webkit-font-smoothing: antialiased
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          overflow: hidden

  .arrow
    width: 0
    height: 0
    border-left: 25px solid transparent
    border-right: 25px solid transparent
    border-bottom: 100px solid #a289cf
    position: relative
    top: -85px
    opacity: 0
    transition: all .4s ease
    &.active
      opacity: 1


  button
    margin-top: 60px
    background: #fcbf00
    border: 0
    height: 60px
    padding: 0 30px
    font-weight: bold
    font-size: 20px
    color: #4f4f4f
    border-radius: 5px
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2)
    outline: none
    cursor: pointer
    z-index: 1
    transition: all .4s ease
    animation: fade .3s ease
    &.cancel
      margin-left: 20px
  .shine
    animation: brillo .5s ease
    animation-iteration-count: 2

  .txt
    margin-top: 1em
    font-family: Montserrat
    color: #FFF
</style>



// WEBPACK FOOTER //
// resources/js/components/Winners2019/SelectWinner.vue